import type { SVGProps } from "react";
export interface ExplosionIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ExplosionIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ExplosionIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M21 19.875a1.125 1.125 0 0 1 0 2.25H3a1.125 1.125 0 0 1 0-2.25zM10.843 2.929c.536-1.493 2.727-1.373 3.098.168l.032.159.832 5.543 1.377-1.203.224-.167c1.073-.67 2.498.14 2.473 1.403l-.028.277-.448 2.463 1.36-.271.156-.025c1.524-.172 2.408 1.726 1.296 2.783l-.117.104-1.781 1.424 1.038.345.107.043a1.125 1.125 0 0 1-.707 2.124l-.111-.032-2.127-.71c-1.222-.407-1.507-2.005-.501-2.809l.7-.561a1.624 1.624 0 0 1-1.69-1.912l.29-1.61-.887.78c-.906.793-2.298.353-2.626-.752l-.052-.23-.553-3.682-.911 3.454a1.626 1.626 0 0 1-2.425.97l-.175-.126L6.92 9.434l.9 2.52a1.625 1.625 0 0 1-1.53 2.17h-.968l.971.773.19.177c.803.867.412 2.307-.719 2.648l-.253.056-2.351.335a1.126 1.126 0 0 1-.32-2.226l.916-.132-1.236-.983c-1.204-.957-.527-2.897 1.012-2.897h1.872L4.046 8.073c-.537-1.502 1.171-2.765 2.437-1.895l.122.09 2.754 2.254 1.435-5.44z"
      />
    </svg>
  );
}
